interface StateType {
    mainBackground: string;
    btn1: string;
    btn2: string;
    listBackground: string;
}
type stateKey = keyof StateType;

interface PayloadType {
    key: stateKey;
    value: string;
}

export default {
    state: {
        mainBackground: '',
        btn1: '',
        btn2: '',
        listBackground: ''
    },
    mutations: {
        setBackgrondValue(state: StateType, playLoad: PayloadType) {
            const { key, value } = playLoad;
            if (state[key]) return;
            state[key] = value;
        }
    },

    namespaced: true
};
